export let ConnectDomainStatusCode = /*#__PURE__*/function (ConnectDomainStatusCode) {
  ConnectDomainStatusCode["VALID"] = "VALID";
  ConnectDomainStatusCode["NS"] = "NS";
  ConnectDomainStatusCode["POINTING"] = "POINTING";
  ConnectDomainStatusCode["INVALID"] = "INVALID";
  return ConnectDomainStatusCode;
}({});
export let ConnectDomainErrorCode = /*#__PURE__*/function (ConnectDomainErrorCode) {
  ConnectDomainErrorCode["DOMAIN_ALREADY_TAKEN"] = "DOMAIN_ALREADY_TAKEN";
  ConnectDomainErrorCode["DOMAIN_NAME_SERVER_NOT_FOUND_BUT_FOR_SELL"] = "DOMAIN_NAME_SERVER_NOT_FOUND_BUT_FOR_SELL";
  ConnectDomainErrorCode["INVALID_DOMAIN_NAME"] = "INVALID_DOMAIN_NAME";
  ConnectDomainErrorCode["ACCESS_DENIED"] = "ACCESS_DENIED";
  ConnectDomainErrorCode["DOMAIN_ALREADY_CONNECTED_SUCCESSFULLY"] = "DOMAIN_ALREADY_CONNECTED_SUCCESSFULLY";
  ConnectDomainErrorCode["CONNECTED_DOMAIN_ASSIGN_SITE"] = "CONNECTED_DOMAIN_ASSIGN_SITE";
  ConnectDomainErrorCode["NO_NAME_SERVERS_FOUND"] = "NO_NAME_SERVERS_FOUND";
  return ConnectDomainErrorCode;
}({});
// registrars list is taken from:
// https://github.com/wix-private/premium/blob/205b2a6987d9b4855b83cc707de018fdbd525453/premium-server/domains-modules/domains-server/src/main/scala/com/wixpress/premium/domains/RegistrarName.scala

export let Registrar = /*#__PURE__*/function (Registrar) {
  Registrar["ALIBABA_CLOUD"] = "ALIBABA_CLOUD";
  Registrar["AMAZON"] = "AMAZON";
  Registrar["ARUBA"] = "ARUBA";
  Registrar["BIG_ROCK"] = "BIG_ROCK";
  Registrar["CRAZY_DOMAINS"] = "CRAZY_DOMAINS";
  Registrar["DOMAIN_DOT_COM"] = "DOMAIN_DOT_COM";
  Registrar["DOMAIN_THE_NET"] = "DOMAIN_THE_NET";
  Registrar["DREAMHOST"] = "DREAMHOST";
  Registrar["DYNADOT"] = "DYNADOT";
  Registrar["ENOM"] = "ENOM";
  Registrar["GABIA"] = "GABIA";
  Registrar["GANDI"] = "GANDI";
  Registrar["GO_DADDY"] = "GO_DADDY";
  Registrar["GOOGLE"] = "GOOGLE";
  Registrar["HOSTINGER"] = "HOSTINGER";
  Registrar["HOSTNET"] = "HOSTNET";
  Registrar["INSTRA"] = "INSTRA";
  Registrar["ISIMTESCIL"] = "ISIMTESCIL";
  Registrar["LCN"] = "LCN";
  Registrar["LOOPIA"] = "LOOPIA";
  Registrar["NAME_CHEAP"] = "NAME_CHEAP";
  Registrar["NAME_DOT_COM"] = "NAME_DOT_COM";
  Registrar["NAME_SCOUT"] = "NAME_SCOUT";
  Registrar["NAME_SILO"] = "NAME_SILO";
  Registrar["NET_REGISTRY"] = "NET_REGISTRY";
  Registrar["ONE_AND_ONE"] = "ONE_AND_ONE";
  Registrar["ONE_DOT_COM"] = "ONE_DOT_COM";
  Registrar["ONE_TWO_THREE_REG"] = "ONE_TWO_THREE_REG";
  Registrar["OVH"] = "OVH";
  Registrar["REG_RU"] = "REG_RU";
  Registrar["REGISTER_DOT_COM"] = "REGISTER_DOT_COM";
  Registrar["REGISTER_SPA"] = "REGISTER_SPA";
  Registrar["RU_CENTER"] = "RU_CENTER";
  Registrar["TRANS_IP"] = "TRANS_IP";
  Registrar["OTHER"] = "OTHER";
  Registrar["ARSYS"] = "ARSYS";
  Registrar["ASCIO"] = "ASCIO";
  Registrar["AUTOMATTIC"] = "AUTOMATTIC";
  Registrar["CRONON"] = "CRONON";
  Registrar["DREAMSCAPE"] = "DREAMSCAPE";
  Registrar["EPAG"] = "EPAG";
  Registrar["FAST_DOMAIN"] = "FAST_DOMAIN";
  Registrar["FBS"] = "FBS";
  Registrar["GMO"] = "GMO";
  Registrar["HETZNER"] = "HETZNER";
  Registrar["INFOMANIAK"] = "INFOMANIAK";
  Registrar["KEY_SYSTEMS"] = "KEY_SYSTEMS";
  Registrar["LAUNCHPAD"] = "LAUNCHPAD";
  Registrar["MESH"] = "MESH";
  Registrar["META_REGISTRAR"] = "META_REGISTRAR";
  Registrar["NETWORK_SOLUTIONS"] = "NETWORK_SOLUTIONS";
  Registrar["NICS"] = "NICS";
  Registrar["ONE_API"] = "ONE_API";
  Registrar["PARAGON"] = "PARAGON";
  Registrar["PUBLIC_DOMAIN_REGISTRY"] = "PUBLIC_DOMAIN_REGISTRY";
  Registrar["PSI_USA"] = "PSI_USA";
  Registrar["REGISTRAR_EU"] = "REGISTRAR_EU";
  Registrar["SYNERGY"] = "SYNERGY";
  Registrar["TUCOWS"] = "TUCOWS";
  Registrar["TURN_COMMERCE"] = "TURN_COMMERCE";
  Registrar["WILD_WILD_WEST"] = "WILD_WILD_WEST";
  Registrar["WIX"] = "WIX";
  return Registrar;
}({});
//# sourceMappingURL=connectDomain.js.map